<template lang="pug">
  v-container(fluid grid-list-md)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{$t('pageHeader.activity')}}
      v-card-title
        v-flex(xs12 sm6)
          VueCtkDateTimePicker(v-model='setDate'
          label="Select Date Range" range @input="setDateTime" overlay)
        v-flex(xs12 sm2)
        v-flex(xs12 sm4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
       
      v-data-table(:headers='headers', :items='activities', :search="search", :loading='loading', :pagination.sync='pagination')
          template(slot='items', slot-scope='props')
            tr.pointer
              td.text-xs-left 
                span.ml-1(class="green--text") {{ props.item.activity }} 
              td.text-xs-left {{ props.item.data }}
              td.text-xs-left {{ props.item.userName }}
              td.text-xs-left {{ props.item.typeId }}
              td.text-xs-left {{ $moment(props.item.createdAt).format('MM/DD/YYYY') }}
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.

</template>

<script>
import activityService from '../service.js';
import { mapGetters } from 'vuex';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(1, 'days'),
        end: this.$moment(new Date())
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(1, 'days').format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(new Date()).format("MM/DD/YYYY h:m a")
      },
      title: "Activites",
      activities : [],
      loading: false,
      headers: [
        {
          text: this.$t('pageHeader.activity'),
          value: 'activity',
          sortable: true,
        },
        {
          text: this.$t('labels.description'),
          value: 'data',
          sortable: true
        },
        {
          text: this.$t('labels.user'),
          value: 'userName',
          sortable: true,
        },
        {
          text: this.$t('labels.type '),
          value: 'typeId',
          sortable: true,
        },
        {
          text: this.$t('labels.createdAt'),
          value: 'createdAt',
          sortable: true,
        },
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'createdAt',
        descending: false,
      },
    }
  },
  components: {
    VueCtkDateTimePicker
  },
  async created(){
      this.getList();
  },
  computed: {
    ...mapGetters('location', ['location'])
  },
  methods: {
    async getList() {
      var proFilter = { }
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a")
      if (this.filter.toDate) 
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      this.loading = true
      return await activityService
      .getAllActivities(proFilter)
      .then((response) => {
        console.log('open invoice list', response)
        this.activities = response
        this.loading = false
        return response
      })
    },
    setDateTime(val) {
      if (val) {
        if (val.start) this.filter.fromDate = val.start
        if (val.end) this.filter.toDate = val.end
        this.getList()
      }
    },
  }
}
</script>

<style scoped>
</style>